import { mockDelay } from '@/services/factory'
import type { ClientPortalService } from './clientPortal.service'
import type { ClientConsent, ClientPortalSnapshot, ClientProfile } from '@/types/clientPortal.types'

const now = new Date()
const iso = (offsetDays: number) => new Date(now.getTime() + offsetDays * 86400000).toISOString()

let snapshot: ClientPortalSnapshot = {
  profile: {
    customerId: '1', fullName: 'Ravi Krishnan', pan: 'ABCDE1234F', status: 'active',
    emailPrimary: 'client.ravi@gmail.com', mobilePrimary: '9876543210', whatsappNumber: '9876543210',
    residentialAddress: { line1: '18 Prabhat Road', city: 'Pune', state: 'Maharashtra', pincode: '411004' },
    correspondenceAddress: { line1: '18 Prabhat Road', city: 'Pune', state: 'Maharashtra', pincode: '411004' },
  },
  filings: [
    { id: 'a-2026', assessmentYear: '2026-27', financialYear: '2025-26', itrType: 'ITR-1', status: 'documents_pending', dueDate: iso(45), totalTaxLiability: 18400 },
    { id: 'a-2025', assessmentYear: '2025-26', financialYear: '2024-25', itrType: 'ITR-1', status: 'processed', filedDate: iso(-260), acknowledgementNumber: 'ACK2025TH001', acknowledgementDate: iso(-260), eVerificationStatus: 'verified', refundAmount: 6200 },
  ],
  documents: [
    { id: 'd-1', name: 'Form-16-2025-26.pdf', category: 'form_16', status: 'verified', fileSize: 384000, isVerified: true, createdAt: iso(-8) },
    { id: 'd-2', name: 'AIS-2025-26.pdf', category: 'ais', status: 'uploaded', fileSize: 226000, isVerified: false, createdAt: iso(-3) },
  ],
  documentRequests: [
    { id: 'r-1', assessmentId: 'a-2026', customerId: '1', customerType: 'individual', financialYear: '2025-26', category: 'bank_statement', title: 'Interest certificate', description: 'Upload the FY 2025-26 bank interest certificate.', isRequired: true, status: 'requested', requestedAt: iso(-2) },
  ],
  reminders: [
    { id: 'rem-1', title: 'Upload interest certificate', description: 'Needed to complete income reconciliation.', dueDate: iso(7), priority: 'high', status: 'pending' },
  ],
  messages: [
    { id: 'msg-1', subject: 'Your return preparation has started', message: 'We have reviewed your Form 16 and AIS.', channel: 'in_app', status: 'delivered', createdAt: iso(-4) },
  ],
  payments: [
    { id: 'pay-1', amount: 3500, currency: 'INR', description: 'ITR preparation fee', status: 'completed', transactionId: 'TXN-TH-1001', paidAt: iso(-12), createdAt: iso(-13) },
  ],
  consents: [
    { id: 'c-1', assessmentId: 'a-2026', version: 1, status: 'pending', statementText: 'I confirm that the information and documents supplied for Assessment Year 2026-27 are complete and authorize my CA firm to file the return shown to me.', requestedAt: iso(-1), expiresAt: iso(10) },
  ],
  warnings: [],
}

export function createMockClientPortalService(): ClientPortalService {
  return {
    async load() { await mockDelay(150); return structuredClone(snapshot) },
    async updateProfile(patch) {
      await mockDelay(120)
      snapshot.profile = { ...snapshot.profile, ...patch } as ClientProfile
      return structuredClone(snapshot.profile)
    },
    async uploadForRequest(request) {
      await mockDelay(180)
      snapshot.documentRequests = snapshot.documentRequests.map((item) => item.id === request.id ? { ...item, status: 'supplied' } : item)
    },
    async decideConsent(consentId, decision, notes) {
      await mockDelay(120)
      let updated: ClientConsent | undefined
      snapshot.consents = snapshot.consents.map((item) => {
        if (item.id !== consentId) return item
        updated = { ...item, status: decision, decisionNotes: notes, decidedAt: new Date().toISOString() }
        return updated
      })
      if (!updated) throw new Error('Consent not found')
      return structuredClone(updated)
    },
    async downloadDocument() { await mockDelay(80); return new Blob(['TaxHive demo document'], { type: 'text/plain' }) },
  }
}
